import dynamic from 'next/dynamic';

export const PersistentCartSummary = dynamic(() => import('./PersistentCartSummary').then(module => module.PersistentCartSummary));
